export default "__VITE_PUBLIC_ASSET__18b7c4ff__"